import OrderAcknowledgement from "@iewc/Components/OrderAcknowledgement";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import React, { FC } from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: any) => ({
    order: state.pages.orderStatus?.order,
});

type Props = ReturnType<typeof mapStateToProps>;

const OrderStatusOrderAcknowledgement: FC<Props> = ({ order }) => {
    return order ? (
      <OrderAcknowledgement {...order} />
    ) : null;
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(OrderStatusOrderAcknowledgement),
    definition: {
        allowedContexts: ["OrderStatusPage"],
        displayName: "Order Acknowledgement",
        group: "Order Status",
    },
};

export default widgetModule;
